import React, { useContext, useEffect } from 'react'
import GameContext from '../GameContext'
import { Container, CardItem, CardDiv, CardImg } from './styles'
import { CardType, initialCard } from '../types'

const GameCards: React.FC = () => {
  const {
    firstSelectedCard,
    setFirstSelectedCard,
    secondSelectedCard,
    setSecondSelectedCard,
    iconFoundList,
    setIconFoundList,
    iconList,
    isPaused,
    isCheckingCards,
    setIsCheckingCards,
    setIsCheckWin,
  } = useContext(GameContext)

  const onSelectCard = (card: CardType) => (): void => {
    if (isCheckingCards) return
    if (firstSelectedCard === initialCard) setFirstSelectedCard(card)
    else setSecondSelectedCard(card)
  }

  const onEndCheckingSelectedCards = (): void => {
    setFirstSelectedCard(initialCard)
    setSecondSelectedCard(initialCard)
    setIsCheckingCards(false)
  }

  const onCheckIfFoundIcon = (): void => {
    if (firstSelectedCard === initialCard) return

    setIsCheckingCards(true)
    const firstSelectedCardIcon = firstSelectedCard
    const secondSelectedCardIcon = secondSelectedCard

    if (firstSelectedCardIcon.name === secondSelectedCardIcon.name) {
      setTimeout(() => {
        const iconFoundListClone = [...iconFoundList]
        iconFoundListClone.push(firstSelectedCardIcon)
        iconFoundListClone.push(secondSelectedCardIcon)
        setIconFoundList(iconFoundListClone)
        setIsCheckWin(true)
        onEndCheckingSelectedCards()
      }, 2000)
    } else {
      setTimeout(onEndCheckingSelectedCards, 2000)
    }
  }

  useEffect(onCheckIfFoundIcon, [secondSelectedCard])

  return (
    <Container>
      {iconList.map((card: CardType, index: number): React.ReactNode => {
        const isVisible = true
        const wasNotFound = iconFoundList.indexOf(card) === -1
        const cardFoundedIndex = Math.floor(iconFoundList.indexOf(card) / 2) + 1
        const isTheFirstSelectedCard = firstSelectedCard === card
        const isTheSecondSelectedCard = secondSelectedCard === card
        const onClick = onSelectCard(card)
        const numOfCardsInEachLine = 5
        const isShowingFrontFace =
          isTheFirstSelectedCard || isTheSecondSelectedCard || !wasNotFound
        const cardCaption = card.caption

        return (
          <CardItem
            key={index}
            onClick={onClick}
            isVisible={isVisible}
            isShowingFrontFace={isShowingFrontFace}
            disabled={isPaused || isShowingFrontFace}
            numOfCardsInEachLine={numOfCardsInEachLine}
          >
            <CardDiv
              isFound={!wasNotFound}
              cardIndex={cardFoundedIndex}
              cardCaption={cardCaption}
            >
              <CardImg src={card.src} id={card.name} />
            </CardDiv>
          </CardItem>
        )
      })}
    </Container>
  )
}

export default GameCards
